import { atom } from 'jotai';

const isSidebarVisibleAtom = atom(false);

const toggleSidebarVisibleAtom = atom(null, (get, set) => set(isSidebarVisibleAtom, !get(isSidebarVisibleAtom)));

export { isSidebarVisibleAtom, toggleSidebarVisibleAtom };
